// src/pages/SettingsLayout.tsx
import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import BackButton from '../components/ui/atoms/BackButton';

export default function SettingsLayout() {
  const navigate = useNavigate();
  return (
    <div className="h-screen flex flex-col">
      {/* always go back to profile or home */}
      {/* <BackButton onClick={() => navigate('/app/profile')} /> */}

      {/* here’s where the menu or sub-page goes */}
      <Outlet />
    </div>
  );
}
